(function (appComponents) {

	var pagerFactory = function (parent) {

		var pagerFactory = {};

		pagerFactory.getPager = function (component) {
			var pager = {
				data: {
					pageToSet: 1,
					currentPage: 1,
					pageSize: 10,
					totalNumberOfResults: 0
				},
				get pageToSet() {
					return (pager._pageToSet) ? pager._pageToSet : pager.data.currentPage;
				},
				get pageSize() {
					return this.data.pageSize;
				},
				elements: {},
				bindings: function () {
					parent._elements.document.off("click", "[pc-container='pager--first-page']").on("click", "[pc-container='pager--first-page']", function () {
						if (pager.data.currentPage === 1) return;
						pager._pageToSet = 1;
						pager.handlers.onPagerClick();
					});
					parent._elements.document.off("click", "[pc-container='pager--prev-page']").on("click", "[pc-container='pager--prev-page']", function () {
						if (pager.data.currentPage === 1) return;
						pager._pageToSet = pager.data.currentPage - 1;
						pager.handlers.onPagerClick();
					});
					parent._elements.document.off("click", "[pc-container='pager--next-page']").on("click", "[pc-container='pager--next-page']", function () {
						if (pager.data.currentPage === pager.data.numberOfPages) return;
						pager._pageToSet = pager.data.currentPage + 1;
						pager.handlers.onPagerClick();
					});
					parent._elements.document.off("click", "[pc-container='pager--last-page']").on("click", "[pc-container='pager--last-page']", function () {
						if (pager.data.currentPage === pager.data.numberOfPages) return;
						pager._pageToSet = pager.data.numberOfPages;
						pager.handlers.onPagerClick();
					});
					parent._elements.document.off("submit", "[pc-container='pager--input-form']").on("submit", "[pc-container='pager--input-form']", function () {
						var formData = parent._utils.getFormData(this);
						if (formData.currentPage > -1 && formData.currentPage <= pager.data.numberOfPages) {
							pager._pageToSet = formData.currentPage;
							pager.handlers.onPagerClick();
						}
						return false;
					});
				}
			};

			pager.reset = function () {
				pager._pageToSet = 1;
				pager.data = {
					currentPage: 1,
					pageSize: 12,
					totalNumberOfResults: 0
				};
			};

			pager.init = function () {
				pager.handlers = component.handlers.pager;
				pager.bindings();

			};

			return pager;
		};


		return pagerFactory;

	};

	if (appComponents.pageComponents == null) appComponents.pageComponents = {};
	if (appComponents.pageComponents.helpers == null) appComponents.pageComponents.helpers = {};
	appComponents.pageComponents.helpers.pagerFactory = pagerFactory;

	window.appComponents = appComponents;

})(window.appComponents || {});